// extracted by mini-css-extract-plugin
export default {"container":"Input_container__8Ef2q","demoSection":"Input_demoSection__4ermu","inputGrid":"Input_inputGrid__FP0gE","inputWrapper":"Input_inputWrapper__WpIwl"};